(function attachBdUserContent(root, factory) {
  const api = factory();
  const target = root;

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  target.BdUserContent = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  const COOKIE_NAME = 'wpfe_bd_user_data';
  const DEFAULT_VARIANT = 'nb-com';
  const USER_TYPE_TO_VARIANT = {
    nb_com: 'nb-com',
    subscriber: 'subscriber',
    non_subscriber: 'non-subscriber',
  };

  function getBdUserTypeFromCookie(cookieString) {
    if (typeof cookieString !== 'string' || !cookieString) {
      return null;
    }

    const prefix = `${COOKIE_NAME}=`;
    const cookie = cookieString
      .split(';')
      .map((entry) => entry.trim())
      .find((entry) => entry.indexOf(prefix) === 0);

    if (!cookie) {
      return null;
    }

    try {
      const data = JSON.parse(decodeURIComponent(cookie.slice(prefix.length)));
      return typeof data.type === 'string' ? data.type : null;
    } catch (error) {
      return null;
    }
  }

  function getBidFromSearch(search) {
    if (typeof search !== 'string' || !search) {
      return null;
    }

    const params = new URLSearchParams(search);
    const bid = params.get('bid');

    return bid || null;
  }

  async function fetchBdUserType(fetchImpl, bid, endpoint = '/wp-json/wpfe/v1/bd-user') {
    if (typeof fetchImpl !== 'function' || !bid) {
      return null;
    }

    try {
      const response = await fetchImpl(`${endpoint}?bid=${encodeURIComponent(bid)}`);

      if (!response || !response.ok || typeof response.json !== 'function') {
        return null;
      }

      const data = await response.json();
      return typeof data.type === 'string' ? data.type : null;
    } catch (error) {
      return null;
    }
  }

  function getVariantForUserType(userType) {
    return USER_TYPE_TO_VARIANT[userType] || DEFAULT_VARIANT;
  }

  function applyVariantToElements(elements, activeVariant) {
    const variant = activeVariant || DEFAULT_VARIANT;

    Array.prototype.forEach.call(elements, (element) => {
      if (!element || !element.dataset) {
        return;
      }

      const variantElement = element;
      variantElement.hidden = variantElement.dataset.bdUserVariant !== variant;
    });
  }

  function renderBdUserContent(rootNode, userType) {
    const variant = getVariantForUserType(userType);

    if (!rootNode || typeof rootNode.querySelectorAll !== 'function') {
      return variant;
    }

    Array.prototype.forEach.call(
      rootNode.querySelectorAll('[data-bd-user-container]'),
      (container) => {
        applyVariantToElements(
          container.querySelectorAll('[data-bd-user-variant]'),
          variant,
        );
      },
    );

    return variant;
  }

  function hideBdUserContent(rootNode) {
    if (!rootNode || typeof rootNode.querySelectorAll !== 'function') {
      return;
    }

    Array.prototype.forEach.call(
      rootNode.querySelectorAll('[data-bd-user-container]'),
      (container) => {
        applyVariantToElements(
          container.querySelectorAll('[data-bd-user-variant]'),
          '__loading__',
        );
      },
    );
  }

  async function initBdUserContent(options = {}) {
    const rootNode = options.rootNode || options.document
      || (typeof document !== 'undefined' ? document : null);
    const doc = options.document || (typeof document !== 'undefined' ? document : null);
    const win = options.window || (typeof window !== 'undefined' ? window : null);
    let cookieString = '';

    if (typeof options.cookieString === 'string') {
      cookieString = options.cookieString;
    } else if (doc && typeof doc.cookie === 'string') {
      cookieString = doc.cookie;
    }

    let userType = getBdUserTypeFromCookie(cookieString);

    if (!userType) {
      let search = '';

      if (typeof options.search === 'string') {
        search = options.search;
      } else if (win && win.location) {
        search = win.location.search;
      }

      const bid = getBidFromSearch(search);
      const fetchImpl = options.fetch
        || (win && typeof win.fetch === 'function' ? win.fetch.bind(win) : null);

      if (bid) {
        hideBdUserContent(rootNode);
        userType = await fetchBdUserType(fetchImpl, bid, options.endpoint);
      }
    }

    renderBdUserContent(rootNode, userType);

    return userType;
  }

  return {
    applyVariantToElements,
    fetchBdUserType,
    getBdUserTypeFromCookie,
    getBidFromSearch,
    getVariantForUserType,
    hideBdUserContent,
    initBdUserContent,
    renderBdUserContent,
  };
}));
